// --- Constants for Navigation components ---
// Header
export const NAVBAR_DEFAULT_HEIGHT = '5rem';
export const NAVBAR_AUTH_HEIGHT = '3.75rem';
export const NAVBAR_AUTH_COLLAPSED_HEIGHT = '3.25rem';

// Sidenav
export const SIDENAV_WIDTH = '13rem';
export const SIDENAV_COLLAPSED_WIDTH = '4rem';
export const SIDENAV_PAGE_CONTENTS_TOP_PAD = '3rem';
export const SIDENAV_TOP_PAD = '3rem';
